import { combineReducers } from "redux";

const modal = (state = false, action) => {
  switch (action.type) {
    case "ExpiredPI_INFO_MODAL":
      return action.val;
    default:
      return state;
  }
};

const ExpiredPIData = (state = { isLoad: false, val: [] }, action) => {
  switch (action.type) {
    case "ExpiredPI_modul":
      return { isLoad: action.load, val: action.val };
    default:
      return state;
  }
};
const MstCustomParam = (state = { isLoad: false, val: [] }, action) => {
  switch (action.type) {
    case "MstCustomParam":
      return { isLoad: action.load, val: action.val };
    case "MstCustomParamSuccessLimit":
      return { isLoad: action.load, val: action.val };
    default:
      return state;
  }
};
const MstCustomParamLoading = (state = { isLoad: false }, action) => {
  switch (action.type) {
    case "MstCustomParamLoading":
      return { isLoad: action.load };
    default:
      return state;
  }
};
const MstCustomParamError = (state = { isLoad: false }, action) => {
  switch (action.type) {
    case "MstCustomParamError":
      return { isLoad: action.load };
    default:
      return state;
  }
};
const MstCustomParamSuccess = (state = { isLoad: false, val: [] }, action) => {
  switch (action.type) {
    case "MstCustomParamSuccess":
      return { isLoad: action.load, val: action.val };
    default:
      return state;
  }
};

const MstCustomParamLimit = (state = { isLoad: false, val: [] }, action) => {
  switch (action.type) {
    case "MstCustomParamLimit":
      return { isLoad: action.load, val: action.val };
    default:
      return state;
  }
};
const MstCustomParamLoadingLimit = (state = { isLoad: false }, action) => {
  switch (action.type) {
    case "MstCustomParamLoadingLimit":
      return { isLoad: action.load };
    default:
      return state;
  }
};
const MstCustomParamErrorLimit = (state = { isLoad: false }, action) => {
  switch (action.type) {
    case "MstCustomParamErrorLimit":
      return { isLoad: action.load };
    default:
      return state;
  }
};
const MstCustomParamSuccessLimit = (
  state = { isLoad: false, val: [] },
  action
) => {
  switch (action.type) {
    case "MstCustomParamSuccessLimit":
      return { isLoad: action.load, val: action.val };
    default:
      return state;
  }
};

const InfoReducer = combineReducers({
  ExpiredPIData,
  modal,
  MstCustomParam,

  MstCustomParamError,
  MstCustomParamSuccess,
  MstCustomParamLoading,

  MstCustomParamLimit,
  MstCustomParamErrorLimit,
  MstCustomParamLoadingLimit,
  MstCustomParamSuccessLimit,
});

export default InfoReducer;
